var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SampleImages',{attrs:{"sample-id":_vm.active_sample.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }